// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3dIph","title":"Info_title__Z7kI6","selects":"Info_selects__TpWdo","requiredAsterisk":"Info_requiredAsterisk__2iX0l"};